export const CLIENT_PATHS = {
  reports: 'reports',
  personalPlan: 'personalplan',
  personalCoach: 'personalcoach',
  deleting: 'deleting',
  emails: 'notifications',
  usergroups: 'usergroups',
  sprints: 'sprints',
  calendar: 'calendar',
  feed: 'feed',
  onboarding: 'onboarding',
  toolbox: 'toolbox',
  mediaLibrary: 'media-library',
  posts: 'posts',
  aiRoleplay: 'ai-roleplay',
  // chat: 'chat',
  absent: 'absent',
  absentManager: 'absentManager',
  poll: 'poll',
  todo: 'todo',
  playBook: 'playbook',
  playBookPilot: 'playbookpilot',
  dashboard: 'dashboard',
  pagebuilder: 'pagebuilder',
  employee: 'employee',
  employeeEdit: 'employeeEdit',
  dataRoom: 'data-room',
  aiSelling: 'ai-selling',
  phonebook: 'phonebook',
  chat: 'chat',
  CRM: 'CRM',
};
export const SUB_PATHS = {};
